import React, { RefObject } from "react";

import LayerItem from "./LayerItem";
import LayerGroup from "./LayerGroup";
import DataSetFilterItem from "../../filter/DataSetFilter/dto/DataSetFilterItem";

interface ItemTreeProps {
    id: string;
    className: string;
    onHide: ((filterId: number, visibility: boolean) => void) | false;
    onAdd: (() => void) | null;
    onRemove: ((filterId: number) => void) | false;
    onRowClick?: () => void;
    onExpand: (itemId: string, expand: boolean) => void;
    onRefresh?: (() => void) | false;
    items: DataSetFilterItem[];
    readonly?: boolean;
    treeRef: RefObject<HTMLDivElement>;
}

const ItemTree = (props: ItemTreeProps) => {
    const items = props.items.map((item) =>
        item.group ? (
            <LayerGroup
                key={props.id + item.id}
                className={props.className}
                children={item.children}
                expanded={item.expanded}
                onExpand={props.onExpand}
                id={item.id}
                onHide={props.onHide}
                visible={item.visibility}
                nesting={1}
                onAdd={props.onAdd}
                onRemove={props.onRemove}
                onRowClick={props.onRowClick}
                onRefresh={props.onRefresh}
                item={item}
            />
        ) : (
            <LayerItem
                key={props.id + item.id}
                className={props.className}
                itemVisible={item.visibility}
                onHide={props.onHide}
                onRemove={props.onRemove}
                onClick={props.onRowClick}
                item={item}
            />
        )
    );
    return (
        <div className={props.readonly ? "treeViewReadonly" : ""} ref={props.treeRef}>
            {items}
        </div>
    );
};

export default ItemTree;
